module.exports = __webpack_public_path__ + "static/media/Login_background.2cb43e64.jpg";